// Localization file, segregated based on game name.
// *** NOTE ***
// Those general info are used across different games
// should always maintained in general object to prevent
// double info. Please refer en.js as full example.

const ko = {
  general: {
    wallet: "베팅 자금",
    menulogout: "HOME",// "로그아웃",
    goodroad: "드래곤 경보",
    menufavourite: "Favourite",
    favouritegame: "Favourite Game",
    availablegame: "Available Game",
    confirm: "Confirm",
    menusfx: "SFX",
    menuon: "실행",
    menuoff: "종료",
    menurules: "규칙",
    menuresult: "결과",
    menustatement: "거래내역서",
    menunotification: "공지",
    menuviewhistory: "기록 보기",
    menufullscreen: "전체화면",
    marketclosed: "마켓 종료",
    menutrend: "트랜드",
    menusimple: "심플",
    menunormal: "보통",

    draw_no: "추첨 번호.",
    rebet: "재베팅",
    no_more_bet: "더이상 베팅 금지",
    sum: "합계",
    next_draw: "다음 추첨",
    last_bets_for: "마지막 베팅",
    bet_total: "총 베팅",
    no_bets_last_round: "마지막 라운드 베팅 없음",
    max: "최대",
    payout: "배당금",
    min_to: "최소",
    max_to: "최대",
    cancel: "취소",
    bet: "베팅하기",
    ref: "참조 번호:",
    gap: "갭",

    sum_bs_short: "합계 빅/스",
    sum_oe_short: "합계 오드/이븐",
    Big: "빅",
    Small: "스몰",
    Even: "이븐",
    Odd: "오드",
    Dice: "주사위",
    Triple: "트리플",
    // High: "높음",
    // Low: "낮음",
    Black: "트리플",
    Red: "레드",
    Joker: "조커",

    //for history TabPane
    Result: "결과",
    Sum_Player: "플레이어 합계",
    Sum_Banker: "뱅커 합계",
    CARD_HISTORY: "카드 기록",
    STATISTICS: "통계",
    RED_BLACK: "레드/블랙",
    HI_LO: "업/다운",
    Player: "플레이어",
    Tie: "동점",
    Banker: "뱅커",

    PLACE_TICKET: "베팅",
    PLACE_FAIL: "베팅 실패!",
    PLACE_SUCCESS: "베팅 성공!",
    ERROR_MIN_TO: "죄송합니다, 최소베팅액보다 낮게 베팅하실 수 없습니다!",
    ERROR_MAX_TO: "죄송합니다, 최대베팅액보다 높게 베팅하실 수 없습니다!",
    ERROR_MAX_DR: "죄송합니다, 추첨 당 최대 베팅을 초과했습니다!",
    ERROR_MAX_BTDR: "죄송합니다, 베팅 유형이 추첨 당 최대 베팅을 초과했습니다!",
    ERROR_NMB: "죄송합니다, 추가 베팅을 하지 마십시오.",
    ERROR_GAME_UA:
      "현재 베팅이 불가능합니다. 자세한 내용은 문의해 주시기 바랍니다, 감사합니다.",
    ERROR_REBET_DONE: "죄송합니다, 귀하는 이미 이전 베팅을 재배팅했습니다.",
    ERROR_TO: "죄송합니다, 판돈을 다시 입력하십시오!",
    ERROR_XAMOUNT: "죄송합니다, 현재 남은 잔액은 베팅하기에 충분하지 않습니다!",
    ERROR_206: "승리 한도 도달! 에이전트에 문의하시기 바랍니다, 감사합니다.",
    ERROR_207: "패배 한도 도달! 에이전트에 문의하시기 바랍니다, 감사합니다.",
    ERROR_208: "계정 일시 정지! 에이전트에 문의하시기 바랍니다, 감사합니다.",
    ERROR_209: "계정 비활성화! 에이전트에 문의하시기 바랍니다, 감사합니다.",
  },

  tai_xiu: {
    dicehistory: "주사위 기록",
    o1group: "빅/트리플/스몰",
    o2group: "빅/트리플/스몰",
    o3group: "빅/트리플/스몰",
    o4group: "오드/이븐",
    o5group: "오드/이븐",

    o11group: "특정 숫자",
    o21group: "특정 숫자",
    o31group: "특정 숫자",
    o41group: "특정 숫자",
    o51group: "특정 숫자",
    o61group: "특정 숫자",
    o104group: "특정 합계",
    o105group: "특정 합계",
    o106group: "특정 합계",
    o107group: "특정 합계",
    o108group: "특정 합계",
    o109group: "특정 합계",
    o110group: "특정 합계",
    o111group: "특정 합계",
    o112group: "특정 합계",
    o113group: "특정 합계",
    o114group: "특정 합계",
    o115group: "특정 합계",
    o116group: "특정 합계",
    o117group: "특정 합계",

    o1: "빅",
    o1_trend: "빅",
    o2: "스몰",
    o2_trend: "스",
    o3: "트리플",
    o3_trend: "AT",
    o4: "오드",
    o4_trend: "오드",
    o5: "이븐",
    o5_trend: "이븐",
    o11: "주사위 1",
    o12: "2x 주사위 1",
    o13: "3x 주사위 1",
    o21: "주사위 2",
    o22: "2x 주사위 2",
    o23: "3x 주사위 2",
    o31: "주사위 3",
    o32: "2x 주사위 3",
    o33: "3x 주사위 3",
    o41: "주사위 4",
    o42: "2x 주사위 4",
    o43: "3x 주사위 4",
    o51: "주사위 5",
    o52: "2x 주사위 5",
    o53: "3x 주사위 5",
    o61: "주사위 6",
    o62: "2x 주사위 6",
    o63: "3x 주사위 6",
    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "10",
    o110_trend: "10",
    o111: "11",
    o111_trend: "11",
    o112: "12",
    o112_trend: "12",
    o113: "13",
    o113_trend: "13",
    o114: "14",
    o114_trend: "14",
    o115: "15",
    o115_trend: "15",
    o116: "16",
    o116_trend: "16",
    o117: "17",
    o117_trend: "17",
    "1_dice": "주사위 1개",
    "2_dice": "주사위 2개",
    "3_dice": "주사위 3개",
  },

  hi_lo: {
    o1: "업",
    o1_trend: "업",
    o2: "다운",
    o2_trend: "다운",
    o3: "레드",
    o3_trend: "레드",
    o4: "블랙",
    o4_trend: "블랙",
    o5: "2-9 범위",
    o5_trend: "2-9",
    o6: "JQKA 범위",
    o6_trend: "JQKA",
    o7: "KA 범위",
    o7_trend: "KA",
    o101: "카드 A",
    o101_trend: "A",
    o102: "카드 2",
    o102_trend: "2",
    o103: "카드 3",
    o103_trend: "3",
    o104: "카드 4",
    o104_trend: "4",
    o105: "카드 5",
    o105_trend: "5",
    o106: "카드 6",
    o106_trend: "6",
    o107: "카드 7",
    o107_trend: "7",
    o108: "카드 8",
    o108_trend: "8",
    o109: "카드 9",
    o109_trend: "9",
    o110: "카드 J",
    o110_trend: "J",
    o111: "카드 Q",
    o111_trend: "Q",
    o112: "카드 K",
    o112_trend: "K",
    o113: "조커",
    o113_trend: "JK",

    //for new-bet-lot
    o1group: "업/다운",
    o2group: "업/다운",
    o3group: "레드/블랙",
    o4group: "레드/블랙",
    o5group: "특정 범위",
    o6group: "특정 범위",
    o7group: "특정 범위",
    o101group: "특정 카드",
    o102group: "특정 카드",
    o103group: "특정 카드",
    o104group: "특정 카드",
    o105group: "특정 카드",
    o106group: "특정 카드",
    o107group: "특정 카드",
    o108group: "특정 카드",
    o109group: "특정 카드",
    o110group: "특정 카드",
    o111group: "특정 카드",
    o112group: "특정 카드",
    o113group: "특정 카드",
  },

  domino: {
    main: "메인",
    result: "메인",
    o1: "플레이어",
    o1_trend: "P",
    o2: "동점",
    o2_trend: "/",
    o3: "뱅커",
    o3_trend: "B",
    o4: "빅",
    o4_trend: "빅",
    o5: "스몰",
    o5_trend: "스",
    o6: "오드",
    o6_trend: "오드",
    o7: "이븐",
    o7_trend: "이븐",
    o8: "빅",
    o8_trend: "빅",
    o9: "스몰",
    o9_trend: "스",
    o10: "오드",
    o10_trend: "오드",
    o11: "이븐",
    o11_trend: "이븐",
    o12_trend: "/",

    //for new-bet-lot
    o1group: "플레이어/동점/뱅커",
    o2group: "플레이어/동점/뱅커",
    o3group: "플레이어/동점/뱅커",
    o4group: "플레이어 빅/스몰",
    o5group: "플레이어 빅/스몰",
    o6group: "플레이어 오드/이븐",
    o7group: "플레이어 오드/이븐",
    o8group: "뱅커 빅/스몰",
    o9group: "뱅커 빅/스몰",
    o10group: "뱅커 오드/이븐",
    o11group: "뱅커 오드/이븐",

    Joker: "조커",

    P_BS: "P 빅/스몰",
    P_OE: "P 오드/이븐",
    B_BS: "B 빅/스몰",
    B_OE: "B 오드/이븐",

    PLAYER: "플레이어",
    BANKER: "뱅커",
    PLAYER_WIN: "플레이어 승리",
    BANKER_WIN: "뱅커 승리",
    TIE: "동점",

    PLAYER_BIG: "플레이어 빅",
    PLAYER_SMALL: "플레이어 스몰",
    PLAYER_ODD: "플레이어 오드",
    PLAYER_EVEN: "플레이어 이븐",

    BANKER_BIG: "뱅커 빅",
    BANKER_SMALL: "뱅커 스몰",
    BANKER_ODD: "뱅커 오드",
    BANKER_EVEN: "뱅커 이븐",
  },

  fantan: {
    o1group: "Fan",
    o2group: "Ssh",
    o3group: "Kwok",
    o4group: "Nim",
    o5group: "Nga",
    o6group: "오드/이븐",
    o7group: "동점",
    total: "총",
    odd: "오드",
    even: "이븐",
    fan: "Fan",
    ssh: "Ssh",
    kwok: "Kwok",
    nga: "Nga",
    nim: "Nim",
    fan1: "Fan1",
    fan2: "Fan2",
    fan3: "Fan3",
    fan4: "Fan4",
    odd_trend: "오드",
    even_trend: "이븐",
    result: "결과",
    history: "기록",
    OE: "오드/이븐",
  },
  
  maxracing: {
    o1: "C(ko)",
    o1_trend: "C(ko)",
    o2: "Big(ko)",
    o2_trend: "B(ko)",
    o3: "Small(ko)",
    o3_trend: "S(ko)",
    o4: "Odd(ko)",
    o4_trend: "O(ko)",
    o5: "Even(ko)",
    o5_trend: "E(ko)",
    o6: "Big(ko)",
    o6_trend: "B(ko)",
    o7: "Small(ko)",
    o7_trend: "S(ko)",
    o8: "Odd(ko)",
    o8_trend: "O(ko)",
    o9: "Even(ko)",
    o9_trend: "E(ko)",
    o10: "G1(ko)",
    o10_trend: "G1(ko)",
    o11: "G2(ko)",
    o11_trend: "G2(ko)",
    o12: "G3(ko)",
    o12_trend: "G3(ko)",
    o13: "G4(ko)",
    o13_trend: "G5(ko)",
    o14: "G5(ko)",
    o14_trend: "G5(ko)",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",

    Champion: "Champion(ko)",
    C_BS: "C B/S(ko)",
    C_OE: "C O/E(ko)",
    S_BS: "S B/S(ko)",
    S_OE: "S O/E(ko)",
    Group: "Group(ko)",
    Place_champ: "Place Champion(ko)",
    Place_sum_champ: "Place Sum Champion(ko)",
    Runner_up: "Runner-up(ko)",
    Race_result: "Race Result(ko)",
  },
};

export default ko;
